export const getLoadId = (uniqueId) => {
  const splitId = uniqueId.split(":");
  return splitId[1] || uniqueId;
};
